import {Injectable, Injector, Type} from '@angular/core';
import {CsAgGridJsAngularCellRenderer} from '@app/shared/cs-ag-grid-js/cs-ag-grid-js-angular-cell-renderer';
import {
    CsAgGridActionRendererComponent
} from '@app/shared/cs-ag-grid-js/cs-ag-grid-cell-renderers/cs-ag-grid-action-renderer/cs-ag-grid-action-renderer.component';
import {
    CsAgGridCellParagraphsRendererComponent
} from '@app/shared/cs-ag-grid-js/cs-ag-grid-cell-renderers/cs-ag-grid-cell-paragraphs-renderer/cs-ag-grid-cell-paragraphs-renderer.component';
import {
    CsAgGridCustomCellRendererComponent
} from '@app/shared/cs-ag-grid-js/cs-ag-grid-cell-renderers/cs-ag-grid-custom-cell-renderer/cs-ag-grid-custom-cell-renderer.component';
import {NoDataFoundComponent} from '@app/shared/cs-components/no-data-found/no-data-found.component';
import {
    CsAgDetailGridRendererComponent
} from '@app/shared/cs-ag-grid-js/cs-ag-grid-cell-renderers/cs-ag-detail-grid-renderer/cs-ag-detail-grid-renderer.component';
import {
    CsAgGridDetailCellRendererComponent
} from '@app/shared/cs-ag-grid-js/cs-ag-grid-cell-renderers/cs-ag-grid-detail-cell-renderer/cs-ag-grid-detail-cell-renderer.component';
import {
    CsAgGridSelectRendererComponent
} from "@app/shared/cs-ag-grid-js/cs-ag-grid-cell-renderers/cs-ag-grid-select-renderer/cs-ag-grid-select-renderer.component";

@Injectable()

export class CsAgGridJsAngularComponentResolverService {

    constructor(private injector: Injector) {
    }

    /* Note: We can use `resolveAngularRendererComponent` function for resolving the external renderer component.
    *   - For Angular component to JS compatibility
    */
    resolveAngularRendererComponent<T>(component: Type<T>) {
        const serviceInjector = this.injector;

        return class extends CsAgGridJsAngularCellRenderer {
            constructor() {
                super(serviceInjector, component);
            }
        };
    }

    // Note: Need to register Cs-Ag-Grid JS's common custom components & renderer components here (No need for individual renderer (internal feature related) components).
    csAgCustomComponents() {
        return {
            actionRenderer: this.resolveAngularRendererComponent(CsAgGridActionRendererComponent),
            paragraphRenderer: this.resolveAngularRendererComponent(CsAgGridCellParagraphsRendererComponent),
            customCellRenderer: this.resolveAngularRendererComponent(CsAgGridCustomCellRendererComponent),
            noRowsOverlay: this.resolveAngularRendererComponent(NoDataFoundComponent),
            detailCellRenderer: this.resolveAngularRendererComponent(CsAgGridDetailCellRendererComponent),
            detailGridRenderer: this.resolveAngularRendererComponent(CsAgDetailGridRendererComponent),
            selectRenderer: this.resolveAngularRendererComponent(CsAgGridSelectRendererComponent)
        };
    }
}
